import * as D from 'ApplicationEntry/models/Dependents';
import * as I from 'immutable';
import {Sex} from 'ApplicationEntry/models/Sex';
import {PhoneNumber} from 'ApplicationEntry/models/PhoneNumber';
import {createAction} from 'Shared/utilities/actionCreator';
import {ZipCode} from 'ApplicationEntry/models/ZipCode';

export const updateFirstName = (index: number, value: string) =>
  createAction(D.DependentActionType.UPDATE_FIRST_NAME_REDUCER, {value, index});
export const updateMiddleName = (index: number, value: string) =>
  createAction(D.DependentActionType.UPDATE_MIDDLE_NAME_REDUCER, {value, index});
export const updateLastName = (index: number, value: string) =>
  createAction(D.DependentActionType.UPDATE_LAST_NAME_REDUCER, {value, index});
export const updateRelationship = (index: number, value: string) =>
  createAction(D.DependentActionType.UPDATE_RELATIONSHIP_REDUCER, {value, index});
export const updateGender = (index: number, value: string) =>
  createAction(D.DependentActionType.UPDATE_SEX_REDUCER, {value, index});
export const updatePhone = (index: number, value: PhoneNumber) =>
  createAction(D.DependentActionType.UPDATE_PHONE_REDUCER, {value, index});
export const updateDOB = (index: number, value: Date | '') =>
  createAction(D.DependentActionType.UPDATE_DOB_REDUCER, {value, index});
export const updateSSN = (index: number, value: string) =>
  createAction(D.DependentActionType.UPDATE_SSN_REDUCER, {value, index});
export const updateAddress = (index: number, value: string) =>
  createAction(D.DependentActionType.UPDATE_ADDRESS_REDUCER, {value, index});
export const updateAddressLine2 = (index: number, value: string) =>
  createAction(D.DependentActionType.UPDATE_ADDRESS_LINE2_REDUCER, {value, index});
export const updateCity = (index: number, value: string) =>
  createAction(D.DependentActionType.UPDATE_CITY_REDUCER, {value, index});
export const updateState = (index: number, value: string) =>
  createAction(D.DependentActionType.UPDATE_STATE_REDUCER, {value, index});
export const updateZip = (index: number, value: ZipCode) =>
  createAction(D.DependentActionType.UPDATE_ZIP_REDUCER, {value, index});
export const addDependent = () => createAction(D.DependentActionType.ADD_DEPENDENT_REDUCER);
export const removeDependent = (index: number) => createAction(D.DependentActionType.REMOVE_DEPENDENT_REDUCER, {index});
export const emptyDependent = () => createAction(D.DependentActionType.EMPTY_DEPENDENT_REDUCER);
export const editDependent = (dependent: D.Dependents) =>
  createAction(D.DependentActionType.EDIT_DEPENDENT_REDUCER, {dependent});

export type Action =
  | ReturnType<typeof addDependent>
  | ReturnType<typeof removeDependent>
  | ReturnType<typeof updateFirstName>
  | ReturnType<typeof updateMiddleName>
  | ReturnType<typeof updateLastName>
  | ReturnType<typeof updateRelationship>
  | ReturnType<typeof updateGender>
  | ReturnType<typeof updatePhone>
  | ReturnType<typeof updateDOB>
  | ReturnType<typeof updateSSN>
  | ReturnType<typeof updateAddress>
  | ReturnType<typeof updateAddressLine2>
  | ReturnType<typeof updateCity>
  | ReturnType<typeof updateState>
  | ReturnType<typeof updateZip>
  | ReturnType<typeof emptyDependent>
  | ReturnType<typeof editDependent>;

export type State = {members: I.List<D.Dependents>};

export function reducer(state: State, action: Action) {
  const newState = {...state};
  let newDependent;
  let oldDependent: D.Dependents;
  switch (action.type) {
    case D.DependentActionType.ADD_DEPENDENT_REDUCER:
      newState.members = state.members.push(D.EmptyDependents);
      return {members: newState.members};
    case D.DependentActionType.REMOVE_DEPENDENT_REDUCER:
      newState.members = state.members.delete(action.payload.index);
      return {members: newState.members};
    case D.DependentActionType.UPDATE_FIRST_NAME_REDUCER:
      oldDependent = state.members.get(action.payload.index) as D.Dependents;
      newDependent = D.changeFirstName(action.payload.value)(oldDependent);
      newState.members = state.members.splice(action.payload.index, 1, newDependent);
      return {members: newState.members};
    case D.DependentActionType.UPDATE_MIDDLE_NAME_REDUCER:
      oldDependent = state.members.get(action.payload.index) as D.Dependents;
      newDependent = D.changeMiddleName(action.payload.value)(oldDependent);
      newState.members = state.members.splice(action.payload.index, 1, newDependent);
      return {members: newState.members};
    case D.DependentActionType.UPDATE_LAST_NAME_REDUCER:
      oldDependent = state.members.get(action.payload.index) as D.Dependents;
      newDependent = D.changeLastName(action.payload.value)(oldDependent);
      newState.members = state.members.splice(action.payload.index, 1, newDependent);
      return {members: newState.members};
    case D.DependentActionType.UPDATE_SEX_REDUCER:
      oldDependent = state.members.get(action.payload.index) as D.Dependents;
      newDependent = D.changeSex(action.payload.value as Sex)(oldDependent);
      newState.members = state.members.splice(action.payload.index, 1, newDependent);
      return {members: newState.members};
    case D.DependentActionType.UPDATE_SSN_REDUCER:
      oldDependent = state.members.get(action.payload.index) as D.Dependents;
      newDependent = D.changeSSN(action.payload.value)(oldDependent);
      newState.members = state.members.splice(action.payload.index, 1, newDependent);
      return {members: newState.members};
    case D.DependentActionType.UPDATE_RELATIONSHIP_REDUCER:
      oldDependent = state.members.get(action.payload.index) as D.Dependents;
      newDependent = D.changeRelationship(action.payload.value)(oldDependent);
      newState.members = state.members.splice(action.payload.index, 1, newDependent);
      return {members: newState.members};
    case D.DependentActionType.UPDATE_PHONE_REDUCER:
      oldDependent = state.members.get(action.payload.index) as D.Dependents;
      newDependent = D.changePhone(action.payload.value)(oldDependent);
      newState.members = state.members.splice(action.payload.index, 1, newDependent);
      return {members: newState.members};
    case D.DependentActionType.UPDATE_ADDRESS_REDUCER:
      oldDependent = state.members.get(action.payload.index) as D.Dependents;
      newDependent = D.changeAddress(action.payload.value)(oldDependent);
      newState.members = state.members.splice(action.payload.index, 1, newDependent);
      return {members: newState.members};
    case D.DependentActionType.UPDATE_ADDRESS_LINE2_REDUCER:
      oldDependent = state.members.get(action.payload.index) as D.Dependents;
      newDependent = D.changeAddressLine2(action.payload.value)(oldDependent);
      newState.members = state.members.splice(action.payload.index, 1, newDependent);
      return {members: newState.members};
    case D.DependentActionType.UPDATE_CITY_REDUCER:
      oldDependent = state.members.get(action.payload.index) as D.Dependents;
      newDependent = D.changeCity(action.payload.value)(oldDependent);
      newState.members = state.members.splice(action.payload.index, 1, newDependent);
      return {members: newState.members};
    case D.DependentActionType.UPDATE_STATE_REDUCER:
      oldDependent = state.members.get(action.payload.index) as D.Dependents;
      newDependent = D.changeState(action.payload.value)(oldDependent);
      newState.members = state.members.splice(action.payload.index, 1, newDependent);
      return {members: newState.members};
    case D.DependentActionType.UPDATE_ZIP_REDUCER:
      oldDependent = state.members.get(action.payload.index) as D.Dependents;
      newDependent = D.changeZip(action.payload.value)(oldDependent);
      newState.members = state.members.splice(action.payload.index, 1, newDependent);
      return {members: newState.members};
    case D.DependentActionType.UPDATE_DOB_REDUCER:
      oldDependent = state.members.get(action.payload.index) as D.Dependents;
      newDependent = D.changeDOB(action.payload.value)(oldDependent);
      newState.members = state.members.splice(action.payload.index, 1, newDependent);
      return {members: newState.members};
    case D.DependentActionType.EMPTY_DEPENDENT_REDUCER:
      return {members: I.List<D.Dependents>().push(D.EmptyDependents)};
    case D.DependentActionType.EDIT_DEPENDENT_REDUCER:
      return {members: I.List<D.Dependents>().push(action.payload.dependent)};
    default:
      console.error('Error occured in Reducer : no case matched');
      return state;
  }
}
